<template>
  <el-dialog :title="$t('base.editAddress')" v-loading="disabled" :visible.sync="dialogVisible" :lock-scroll="false" top="10vh" width="680px" :before-close="handleClose">
    
    <div class="dialogData">
      <!-- <a v-if="businessType==2&&checkAdd.Country!='CN'" href="https://www.shipmycards.com/" target="_blank" class="tryShipMyCards">Try ShipMyCards →</a> -->
      <el-form :model="checkAdd" :rules="passRules" ref="passForm" :hide-required-asterisk='true' class="set_form">
        <div class="address_box country">
          <el-form-item :label="$t('colon.country')" class="info_box" prop="Country">
            <!--  <el-select v-model="checkAdd.Country" class="info_ipt">
              <el-option :label="checkAdd.Country" :value="checkAdd.Country"></el-option>
            </el-select> -->
            <el-input class="info_ipt" v-model="checkAdd.Country" :disabled="true"></el-input>
          </el-form-item>
          <!-- <div class="currently">Currently, we only accept U.S. address.</div> -->
        </div>
        <div class="address_box">
          <el-form-item :label="$t('colon.name')" class="info_box" prop="UserName">
            <el-input class="info_ipt" v-model="checkAdd.UserName" max="30"></el-input>
          </el-form-item>
        </div>
        <div class="address_box">
          <el-form-item :label="$t('colon.street1')" class="info_box" prop="StreetAddress">
            <el-input class="info_ipt" v-model="checkAdd.StreetAddress" max="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('colon.street2')" class="info_box" prop="StreetAddress2">
            <el-input class="info_ipt" v-model="checkAdd.StreetAddress2" max="100"></el-input>
          </el-form-item>
        </div>
        <div class="address_box">
          <el-form-item :label="$t('colon.city')" class="info_box" prop="City">
            <el-input class="info_ipt" v-model="checkAdd.City" max="30"></el-input>
          </el-form-item>
          <el-form-item :label="$t('colon.state')" class="info_box" prop="StateCode">
            <el-select v-model="checkAdd.StateCode" filterable class="info_ipt" @change='getState' :placeholder="$t('base.selectState')">
              <el-option :label="item.EName" :value="item.Code" v-for="(item,index) in getAreas" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="address_box">
          <el-form-item :label="$t('colon.zipCode')" class="info_box" prop="ZipCode">
            <el-input class="info_ipt" v-model="checkAdd.ZipCode" max="30"></el-input>
          </el-form-item>
          <el-form-item :label="$t('colon.phone')" class="info_box" prop="Phone">
            <el-input class="info_ipt" v-model="checkAdd.Phone" max="30"></el-input>
          </el-form-item>
        </div>
        <!-- 先隐藏，后续出 -->
        <!-- <el-checkbox class="checkbox_save" v-if="!checkAdd.IsDefault" v-model="checkAdd.IsDefault">Save as primary address</el-checkbox> -->
        <div class="set_btn">
          <el-button @click="resetForm('passForm')">{{$t('base.cancel')}}</el-button>
          <el-button type="primary" :disabled="disabled" @click="submitForm('passForm')">{{$t('base.save')}}</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { getUser, isEmoji } from "@/api/public";
export default {
  name: 'addressbox',
  data() {
    var isChinese = (rule, value, callback) => {
      let that=this
      let msg = this.$t('rules.enterAddress')
      if (value == '' && rule.field == 'StreetAddress') {
        callback(new Error(msg));
      }
      let Country=''
      if(this.userInfo){
        Country=this.userInfo.MemberSource
      }
      //console.log(Country,this.userInfo,'Country')
      let isChinese = 'HK,TWN,MO,CN'
      //console.log(this.checkAdd.Country,isChinese.indexOf(this.checkAdd.Country))
      if (isChinese.indexOf(Country) > -1) {
        let text = this.checkAdd.StreetAddress + this.checkAdd.StreetAddress2
        let reg = /[\u4E00-\u9FA5]/g;
        let ChineseLength = (text.match(reg) || []).length
        if (ChineseLength < 4) {
          msg = this.$t('rules.isChinese')
          callback(new Error(msg));
        }
        setTimeout(() => {
          if (rule.field == 'StreetAddress') {
            if(ChineseLength < 4){
              that.$refs['passForm'].validateField('StreetAddress2')
            }
          }
          if (rule.field == 'StreetAddress2') {
            that.$refs['passForm'].validateField('StreetAddress')
          }
        })
      }
      callback();
    }
    return {
      disabled: false,

      passRules: {
        Country: [
          { required: true, message: this.$t('rules.enterCountry'), trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: this.$t('rules.enterName'), trigger: 'blur' }
        ],
        StreetAddress: [
          { validator: isChinese, trigger: 'blur' },
          // { required: true, message: this.$t('rules.enterAddress'), trigger: 'blur' }
        ],
        StreetAddress2: [
          { validator: isChinese, trigger: 'blur' },
          //{ required: true, message: 'Please enter your Address2', trigger: 'blur' }
        ],
        City: [
          { required: true, message: this.$t('rules.enterCity'), trigger: 'blur' }
        ],
        StateCode: [
          { required: true, message: this.$t('rules.selectState'), trigger: 'change' }
        ],
        ZipCode: [
          { required: true, message: this.$t('rules.enterZipCode'), trigger: 'blur' }
        ],
        Phone: [
          { required: true, message: this.$t('rules.enterPhone'), trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    dialogVisible: Boolean,
    checkAdd: '',
    getAreas: '',
    userInfo: Object,
    isNew: Boolean,
    businessType: '',
    type: 0 // 0 官方商城，1 竞拍，一口价 2转运仓
  },
  created() {},
  methods: {
    forbidInput(val) {
      if (val == 'address') {
        this.checkAdd.StreetAddress = isEmoji(this.checkAdd.StreetAddress, 0)
      } else if (val == 'address2') {
        this.checkAdd.StreetAddress2 = isEmoji(this.checkAdd.StreetAddress2, 0)
      }
    },

    //select 州
    getState(val) {
      let that = this
      // console.log(that.getAreas,val,'that.getAreas')
      that.getAreas.map(res => {
        if (res.Code == val) {
          that.checkAdd.State = res.EName
          // console.log(that.checkAdd.State,'that.getAreas')
        }
      })
    },
    //保存地址
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = this.$interface.SaveAddresses
          let data = {
            "memberId": that.userInfo.Id,
            "country": that.checkAdd.Country,
            "userName": that.checkAdd.UserName,
            "streetAddress": that.checkAdd.StreetAddress,
            "streetAddress2": that.checkAdd.StreetAddress2,
            "city": that.checkAdd.City,
            "stateCode": that.checkAdd.StateCode,
            "state": that.checkAdd.State,
            "zipCode": that.checkAdd.ZipCode,
            "phone": that.checkAdd.Phone,
            // 'isDefault':that.checkAdd.IsDefault
          }
          if (!this.isNew) {
            url = this.$interface.UpdateAddresses;
            data.id = that.checkAdd.Id
            data.isDefault = that.checkAdd.IsDefault || false
          }
          if (this.businessType == 2 && this.isNew) {
            url = this.$interface.SaveMemberAreas
            data.token = that.userInfo.ChineseToken
            data.operator_id = that.userInfo.MappingUserId
          } else if (this.businessType == 2 && !this.isNew) {
            url = this.$interface.SetMembeUpdateInfo
            data.id = that.checkAdd.Id
            data.token = that.userInfo.ChineseToken
            data.operator_id = that.userInfo.MappingUserId
          }
          // console.log(url, data, 'url,data')
          that.disabled = true;
          this.$post(url, data).then(res => {
            // console.log(res, 'result', that.lowerJSONKey(res))
            var res = that.lowerJSONKey(res)
            if (res.result != 0) {
              // 父类方法
              if (that.businessType == 2) {
                //跨境
                that.$parent.getMemberAreas(that.checkAdd.Country);
              } else {
                // 非跨境
                that.$parent.getAddressList(this.isNew);
              }
              //this.getAddressList(this.isNew);
              //that.dialogVisible = false;
              that.$emit('update:dialogVisible', false)
              that.$refs[formName].resetFields();
              that.disabled = false;
            } else {
              that.disabled = false;
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          })
          //console.log(url, data)
        }
      });
      //this.dialogVisible = false
    },
    //取消保存地址
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleClose()
    },
    // 关闭
    handleClose() {
      if (this.type == 1) {
        this.$parent.doneAddress();
      }
      this.$emit('update:dialogVisible', false)
      this.disabled = false;
    },
    lowerJSONKey(json) {
      var isLower = new RegExp("[a-z]+")
      for (var key in json) {
        if (!isLower.test(key)) {
          json[key.toLowerCase()] = json[key];
          delete(json[key])
        }
      }
      return json;
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.address_box {
  width: 100%;
  display: flex;
}

.info_box {
  width: 240px;
  margin-left: 24px;
}

.address_box.country {
  margin-bottom: 10px;
  position: relative;
}

.address_box.country .currently {
  position: absolute;
  top: 65px;
  left: 24px;
  font-size: 12px;
  color: #999;
}

.set_btn {
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/orderaddress.vue